import React from 'react';
import styles from './ProgressBar.module.css';

interface Props {
  uploadProgress: number;
  'aria-label'?: string;
  'aria-valuemin'?: number;
  'aria-valuemax'?: number;
}

const ProgressBar = ({ uploadProgress, ...rest }: Props) => {
  return (
    <div className={styles.wrapper}>
      <progress
        className={styles.progress}
        value={uploadProgress}
        style={{
          display: `${uploadProgress === 0 ? 'none' : 'block'}`,
        }}
        aria-valuenow={uploadProgress}
        aria-valuemin={0}
        aria-valuemax={100}
        {...rest}
      />
    </div>
  );
};

export default ProgressBar;
